import React from "react";
import { SanityRawContent } from "../../model/common";
import BlockContent from "../BlockContent/BlockContent";
import styles from "./CardHero.module.scss";
import classnames from "classnames";

interface CardHeroProps {
  node: { content: SanityRawContent };
}

const CardHero = ({ node: { content } }: CardHeroProps) => (
  // Global class is a spacing hack. See spacing module.
  <div className={classnames("cardHero", styles.hero)}>
    <BlockContent content={content} />
  </div>
);

export default CardHero;
